import { Component, OnInit, ViewChild } from '@angular/core';
import { ShipmentLists } from '../models/shipment-lists.model';
import { HttpClient } from '@angular/common/http';
import { map, catchError, filter } from 'rxjs/operators';
import { of } from 'rxjs';
import { GridApi, IServerSideDatasource, IServerSideGetRowsParams, ICellRendererParams, CellClassParams, GridOptions, ColDef } from 'ag-grid-community';
import { ShipmentDetailsComponent } from './shipment-details/shipment-details.component';
import { ShipmentOrderCreatorComponent } from './shipment-order-creator/shipment-order-creator.component'
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AgGridAngular } from 'ag-grid-angular';

@Component({
  selector: 'app-shipment-lists',
  templateUrl: './shipment-lists.component.html',
  styleUrls: ['./shipment-lists.component.scss']
})
export class ShipmentListsComponent implements OnInit {

  @ViewChild('agGrid', { static: false }) agGrid!: AgGridAngular;

  searchShipment: FormGroup = this.fb.group({
    asn_number: [''],
    trip_number: [''],
    store_number: [''],
  })

  listOfASNNumber = [];
  listOfTripNumber = [];
  listOfStoreNumber = [];


  // assign Contact Details component to be the detail cell rendered
  public detailCellRenderer: any = ShipmentDetailsComponent;

  // set initial static height for the detail grid
  detailRowHeight = 500;

  rowData: ShipmentLists[] = [];

  // variable to store universal filter 
  universalFilter = ''

  // default column definitions
  defaultColDef = {
    sortable: true,
    filter: 'agTextColumnFilter',
    filterParams: {
      caseSensitive: false,
    },
    autoHeight: true,
    cellClass: 'cell-wrap-text',
    resizable: true,
    editable: true
  };

  // define headers for the main shipment list grid
  columnDefs: ColDef[] = [
    { field: 'shipment_list_uuid', headerName: 'UUID', hide: true },
    { field: 'asn_number', headerName: 'ASN No.', cellRenderer: 'agGroupCellRenderer' },
    { field: 'trip_number', headerName: 'Trip No.', width: 110 },
    { field: 'act_trail_number', headerName: 'ACT Trailer No.', width: 170 },
    { field: 'store_number', headerName: 'Store No.', width: 120 },
    { field: 'week_no', headerName: 'Week No.', width: 130 ,
        filterParams: {
          filterOptions: ['equals','notEqual','before','after','inRange']
        }
    },
    {
      field: 'status', headerName: 'Status', cellRenderer: statusTypeFormatting, filter: 'agSetColumnFilter', filterParams: {
        values: [
          'Receiving in Progress',
          'Received Completed',
          'Auditing in Progress',
          'Audit Completed',
          'Work Order Created',
          'Container Created',
          'Intermodal Created',
        ]
      },
    },
    { field: 'alternate_reference', headerName: 'FBI No.', cellStyle: {'font-weight': 'bold'}},
    { field: 'created', headerName: 'Date of Scan',  valueGetter: params => this.formatDateString(params.data.created)},
    { field: 'total_cartons', headerName: 'Expected', width: 140, filter: false },
    { field: 'total_boxes', headerName: 'Actual', width: 140, filter: false },
    { field: 'received_in', headerName: 'Received In', width: 130, filter: false },
    { field: 'audited', headerName: 'Audited', width: 110, filter: false },
    { 
      field: 'missing', 
      headerName: 'Missing', 
      width: 110,
      cellStyle: (params : CellClassParams) => {
        // make background colour Red if not zero
        if (params.value === 0) return null
        return {color:'red'}; 
      }, 
      filter: false,
    },
    { 
      field: 'overage', 
      headerName: 'Overage', 
      width: 110,
      cellStyle: (params : CellClassParams) => {
        // make background colour Red if not zero
        if (params.value === 0) return null
        return {color:'red', 'font-weight': 'bold'}; 
      },     
      filter: false,    
    },
  ]

  constructor(private http: HttpClient, private fb: FormBuilder, private route: ActivatedRoute, private router: Router) { }

  ngOnInit(): void {
    const url = '/api/shipment_lists/shipment_trip_lists.php';
    const urlStore = '/api/shipment_lists/shipment_trip_lists.php';
    this.http.get<any>(urlStore, { params: { store: "spencer gifts" } }).subscribe(response => {
      this.listOfStoreNumber = response.stores.map((item: any) => {
        const inputString = item.contact_organization;
        const parts = inputString.split('#'); // Split the string using the hash sign as the delimiter
        const textAfterHash = parts[1];
        return textAfterHash;
      })
    });
    this.http.get<any>(url, { params: { trip: "spencer gifts" } }).subscribe(response => {
      console.log('Trip_list:', response.data)
      this.listOfTripNumber = response.data.trip_number_only;
      this.listOfASNNumber = response.data.asn_number_only;
    })
  }

  ngAfterViewInit() {
    if (this.agGrid) {
      this.route.queryParamMap.subscribe((params) => {
        const asnText = params.get('asnNumber');
        const tripText = params.get('tripNumber');
        const storeText = params.get('storeNumber');

        if (asnText) {
          this.applyAsnFilter(asnText);
        }
        else if (tripText) {
          this.applyTripFilter(tripText);
        }
        else if (storeText) {
          this.applyStoreFilter(storeText);
        }
        else {
          this.agGrid.api.setFilterModel(null);
        }
      });
    }
  }

  applyAsnFilter(filterText: string) {
    if (this.agGrid) {
      this.agGrid.api.setFilterModel({
        asn_number: {
          filterType: "text",
          type: "equals",
          filter: filterText,
        },
      });
      this.agGrid.api?.onFilterChanged();
    }
  }

  applyTripFilter(filterText: string) {
    if (this.agGrid) {
      this.agGrid.api.setFilterModel({
        trip_number: {
          filterType: "text",
          type: "equals",
          filter: filterText,
        },
      });
      this.agGrid.api?.onFilterChanged();
    }
  }

  applyStoreFilter(filterText: string) {
    if (this.agGrid) {
      this.agGrid.api.setFilterModel({
        store_number: {
          filterType: "text",
          type: "equals",
          filter: filterText,
        },
      });
      this.agGrid.api?.onFilterChanged();
    }
  }

  private formatDateString(value: string | null): string {
    if (!value || isNaN(new Date(value).getTime())) return '';
    return value.split(' ')[0];
  }

  search() {
    const asnNumber = this.searchShipment.get('asn_number')?.value;
    const tripNumber = this.searchShipment.get('trip_number')?.value;
    if (asnNumber) {
      this.router.navigate(['/shipments'], { queryParams: { asnNumber: asnNumber } });
    }
    else if (tripNumber) {
      this.router.navigate(['/shipments'], { queryParams: { asnNumber: tripNumber } });
    }
    else {
      console.log('Invalid search data.')
    }
  }

  resetSearch() {
    this.router.navigate(['/shipments']);
    this.searchShipment.get('asn_number')?.setValue('');
    this.searchShipment.get('trip_number')?.setValue('');
  }

  asnNumberChange(event: any) {
    this.router.navigate(['/shipments'], { queryParams: { asnNumber: event.value } });
  }

  tripNumberChange(event: any) {
    this.router.navigate(['/shipments'], { queryParams: { tripNumber: event.value } });
  }

  storeNumberChange(event: any) {
    this.router.navigate(['/shipments'], { queryParams: { storeNumber: event.value } });
  }

  // agInit(params: any): void {

  //   console.log('hello')

  //   const contact_details_url = `/api/shipment_lists/shipment_lists.php`;

  //   this.http.get<any>(contact_details_url).subscribe(response => {
  //     this.rowData = response.data
  //     console.log(this.rowData)
  //   })

  // }

  private gridApi!: GridApi;

  // on grid loading, call API to retrieve shipment list data
  onGridReady(params: any) {
    this.gridApi = params.api
    params.api.setGridOption("serverSideDatasource", this.getServerSideDatasource());
    this.gridApi = params.api;
    // // Resize columns to fit the grid width
    this.gridApi?.addEventListener('firstDataRendered', () => {
      this.autoSizeAll(false);
    });
  }

  autoSizeAll(skipHeader: boolean) {
    const allColumnIds: string[] = [];
    this.gridApi.getColumns()!.forEach((column) => {
      allColumnIds.push(column.getId());
    });
    this.gridApi.autoSizeColumns(allColumnIds, skipHeader);
  }

  onFilterTextBoxChanged() {
    this.gridApi.setGridOption("serverSideDatasource", this.getServerSideDatasource());
  }


  getServerSideDatasource(): IServerSideDatasource {
    return {
      getRows: (params: IServerSideGetRowsParams) => {
        this.getShipments(params.request.startRow, params.request.endRow, params.request.filterModel, params.request.sortModel)
          .subscribe(
            response => {
              if (response) {
                params.success({ rowData: response.rowData, rowCount: response.rowCount });
              } else {
                params.fail();
              }
            },
            error => {
              console.log(error);
              params.fail();
            }
          );
      }
    };
  }

  getShipments(startRow: number = 0, endRow: number = 0, filterModel: any = {}, sortModel: any = []) {
    const apiUrl = '/api/shipment_lists/shipment_lists.php';
    const filters = Object.entries(filterModel).map(([column, filter]: [string, any]) => {
      console.log('Filter model:', filterModel);
      console.log('Filter', filter)

      let operator = '';
      let value = '';

      if (filter.filterType === 'text') {
        operator = filter.type;
        value = filter.filter;
      } else if (filter.filterType === 'set') {
        operator = 'equals'; // Or any other appropriate operator for set filter
        value = filter.values.join(','); // Join selected values with a delimiter if needed
      }

      return {
        column,
        operator,
        value,
      };
    });

    //changed this back to use the defaults
    // const filters = Object.entries(filterModel).map(([column, filter]: [string, any]) => {
    //   return {
    //     column,
    //     operator: filter.type === 'contains' ? 'LIKE' : '=',
    //     value: filter.type === 'contains' ? `%${filter.filter}%` : filter.filter,
    //   };
    // });

    const params: any = {
      startRow: startRow,
      endRow: endRow,
      sortModel: JSON.stringify(sortModel),
      filters: JSON.stringify(filters),
    };
    console.log(filters)
    const url = `${apiUrl}?startRow=${startRow}&endRow=${endRow}&universalFilter=${this.universalFilter}`;
    return this.http.get<any>(url, { params }).pipe(
      map((response) => {
        return {
          rowData: response.data,
          rowCount: response.total,
        };
      }),
      catchError((error) => {
        console.log(error);
        return of(null);
      }),
      filter(response => response !== null)
    );
  }

  refresh(params: any): boolean {
    return false;
  }

}

// function for custom cell renderer for shipment types (colored)
function statusTypeFormatting(params: ICellRendererParams) {
  let statusTypes: string[] = []
  if (params.value != null) {
    statusTypes = params.value.split(",");
  }
  let buttonsHtml = '';

  for (let type of statusTypes) {
    let trimmedType = type.trim();
    let bgColor = '';

    switch (trimmedType) {
      case 'Work Order Created':
        bgColor = '#FF0000';
        break;
      case 'Container Created':
          bgColor = '#FA7878';
          break;
      case 'Intermodal Created':
            bgColor = '#F9A5A5';
            break;                  
      case 'Audit Completed':
        bgColor = '#00FF00';
        break;
      case 'Receiving in Progress':
        bgColor = '#99CCFF';
        break;
      case 'Received Completed':
        bgColor = '#3399FF';
        break;
      case 'Auditing in Progress':
        bgColor = "#CCFF99"
        break;
      default:
        bgColor = '#FFFFFF';
    }

    buttonsHtml += '<button class="btn dropdown-toggle button-text-wrapper" style="background-color:' + bgColor + ';border-radius:10px;font-weight:bold;">' + trimmedType + '</button> <br>';
  }

  let element = '<div class="btn-group">' + buttonsHtml + '</div>';

  return element;
}
